export const appLanguages = {
    'he': { lang: 'he', dir: 'rtl'},
    'en': { lang: 'en', dir: 'ltr'}
};